import { render, staticRenderFns } from "./LegendDescEdit.vue?vue&type=template&id=42117a94&"
import script from "./LegendDescEdit.vue?vue&type=script&lang=ts&"
export * from "./LegendDescEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports